import { IApplicationState } from '../../types/redux';

export const selectRecommendations = (state: IApplicationState) => {
  return state.newbuildingRecommendations.newbuildings;
};
